<template>
    <div>
        <el-card shadow="hover">
            <el-form inline :model="query" size="small">
                <div @keydown.enter="doLoad()">
                    <div style="float: left;">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doLoad">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-card>

        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="考场信息">
                    <template slot-scope="scope">
                        <p>
                            <span>[{{ scope.row.name }}] {{ scope.row.room }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="最大人数" width="200">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.max }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="排座人数" width="200">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.sdc }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="进场人数" width="200">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.inc }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="人脸识别" width="200">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.atc }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="人工审核" width="200">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.mac }}人</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="300" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-view" v-has="'PlatAdmin'" @click.stop="doPreviewZcb(scope.row)">
                            查看进场照片
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
const defaultQuery = {
    pid: ''
}

export default {
    name: 'RecVStat',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                count: 0,
                regs: 0,
                pass: 0,
                paid: 0
            },
            tableLoading: false,
            datas: [],
            plans: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '进场统计'])
        this.init()
    },

    methods: {
        init() {
            this.doLoadPlan()
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                })
        },
        doLoad() {
            if (!this.query.pid) {
                this.$message.warning('请选择招聘计划')
                return
            }
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/venues/stat', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    this.datas = result.datas
                })
        },
        doPreviewZcb(item) {
            this.$http
                .get('/ops/recruit/seats/zcb/preview', {
                    params: {
                        _: new Date().getTime(),
                        vid: item.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        }
    }
}
</script>
